import { render, staticRenderFns } from "./ProgramTaylorMade.vue?vue&type=template&id=52145bc2&scoped=true&"
import script from "./ProgramTaylorMade.vue?vue&type=script&lang=js&"
export * from "./ProgramTaylorMade.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTaylorMade.vue?vue&type=style&index=0&id=52145bc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52145bc2",
  null
  
)

export default component.exports